const ALWAYS_VISIBLE_SELECTOR =
  '[data-live-announcer], [data-react-aria-top-layer]';

export const ariaHideOutside = (target: Element): (() => void) => {
  const visibleElements: Element[] = [
    target,
    ...Array.from(document.querySelectorAll(ALWAYS_VISIBLE_SELECTOR)),
  ];
  const hiddenElements: Element[] = [];

  const hideChildrenOutsideVisible = (parent: Element): void => {
    Array.from(parent.children).forEach(child => {
      if (visibleElements.includes(child)) return;
      if (visibleElements.some(visible => child.contains(visible))) {
        hideChildrenOutsideVisible(child);
        return;
      }
      if (child.getAttribute('aria-hidden') === 'true') return;
      child.setAttribute('aria-hidden', 'true');
      hiddenElements.push(child);
    });
  };

  hideChildrenOutsideVisible(document.body);

  return () => {
    hiddenElements.forEach(element => element.removeAttribute('aria-hidden'));
  };
};
